import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID,
    ACTION_GROUPFINANCE_LOAD_BY_ID,

    ACTION_GROUPFINANCE_SAVE,

    ACTION_GROUPFINANCE_CREATE,

    ACTION_GROUPFINANCE_VALIDATE,

    IGroupFinanceLoadByGroupIdAction,
    IGroupFinanceLoadByIdAction,
    IGroupFinanceLoadFailureAction,
    IGroupFinanceLoadSuccessAction,

    IGroupFinanceSaveAction,
    IGroupFinanceSaveSuccessAction,
    IGroupFinanceSaveFailureAction,

    IGroupFinanceCreateAction,
    IGroupFinanceCreateSuccessAction,
    IGroupFinanceCreateFailureAction,

    IGroupFinanceValidateAction,
    IGroupFinanceValidateSuccessAction,
    IGroupFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/groupFinance";
import { groupFinanceApi } from "../services/groupFinance";

export const
    getGroupFinanceByGroupIdEpic = (action$): Observable<IGroupFinanceLoadSuccessAction | IGroupFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID)
            .mergeMap((action: IGroupFinanceLoadByGroupIdAction) => {
                return groupFinanceApi
                    .getGroupFinanceByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupFinanceByIdEpic = (action$): Observable<IGroupFinanceLoadSuccessAction | IGroupFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPFINANCE_LOAD_BY_ID)
            .mergeMap((action: IGroupFinanceLoadByIdAction) => {
                return groupFinanceApi
                    .getGroupFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupFinanceEpic = (action$): Observable<IGroupFinanceSaveSuccessAction | IGroupFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPFINANCE_SAVE)
            .mergeMap((action: IGroupFinanceSaveAction) => {
                return groupFinanceApi
                    .setGroupFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupFinanceEpic = (action$): Observable<IGroupFinanceCreateSuccessAction | IGroupFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPFINANCE_CREATE)
            .mergeMap((action: IGroupFinanceCreateAction) => {
                return groupFinanceApi
                    .createGroupFinance(action.groupId)
                    .map(response =>
                        CreateSuccess(
                            response.groupFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateGroupFinanceEpic = (action$): Observable<IGroupFinanceValidateSuccessAction | IGroupFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPFINANCE_VALIDATE)
            .mergeMap((action: IGroupFinanceValidateAction) => {
                return groupFinanceApi
                    .validateGroupFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.groupFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }